import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { PaymentDetailVerification } from "@/types/payment";

interface VerificationStatusProps {
  hostId: string;
  verification: PaymentDetailVerification;
}

export const VerificationStatus = ({ hostId, verification }: VerificationStatusProps) => {
  if (!verification) return null;

  return (
    <div className="mt-4">
      <h3 className="text-lg font-medium">Verification Status</h3>
      <div className="mt-2">
        <p>Status: {verification.status}</p>
        {verification.kycStatus && (
          <p>KYC Status: {verification.kycStatus}</p>
        )}
        {verification.kycRejectionReason && (
          <p className="text-red-500">
            Reason: {verification.kycRejectionReason}
          </p>
        )}
      </div>
    </div>
  );
};